<script>
	export default {
		props: {
			contacto: {
				type: Object,
				required: true
			}
		},
		methods: {
			// favoriteToggle() {
			// 	this.contacto.favorito = !this.contacto.favorito;
			// },
			volver() {
				this.$emit('volver');
			},
			enviarMensaje() {
				this.$emit('enviarMensaje', this.contacto);
			}
		},
	}
</script>
<template>
	<section id="detalle-contacto">
		<div class="d-flex justify-content-between align-items-center mb-4">
			<a 
				@click="volver()"
				href="javascript:"
				class="btn btn-custom-line-main btn-sm me-2"
			>
			<font-awesome-icon icon="fa-solid fa-angle-left" class="me-1"></font-awesome-icon>

				Volver
			</a>
		</div>
		<div class="d-flex flex-column overflow-contacto">
			<div class="d-flex align-items-start border-bottom mb-4 pb-4">
				<div class="flex-shrink-0">
					<img 
						v-if="contacto.imagen_perfil"
						width="120"
						height="120"
						class="img-object-cover rounded-circle border border-main p-1"
						:src="contacto.imagen_perfil"
						:alt="contacto | userFullName | initials"
					>
					<img 
						v-if="!contacto.imagen_perfil"
						width="120"
						height="120"
						class="img-object-cover rounded-circle border border-main p-1"
						src="@/assets/img/intranet/header/icono-header-btn-contacto.svg"
					>
				</div>
				<div class="flex-grow-1 ms-3">
					<h4 class="d-grid color-main mt-2 mb-4">
						<strong class="ellipsis-custom">
						{{ contacto.primer_nombre }}<br> {{ contacto.apellido_paterno }}
						</strong>
					</h4>
					<span class="circle-text bg-main me-1"></span>
					<span class="circle-text bg-main me-1"></span>
					<span class="circle-text bg-main me-1"></span>
				</div>
			</div>
			<div class="d-flex">
				<ul class="list-group list-group-flush">
					<li class="list-group-item border-0">
						<p class="text-secondary mb-0">
							<strong>Cargo</strong><br>
							<span class="text-secondary text-opacity-75 ellipsis-custom">
								{{ contacto.cargo[0]?.nombre_cargo | capitalizeFirstChars }}
							</span>
						</p>
					</li>
					<li class="list-group-item border-0">
						<p class="text-secondary mb-0">
							<strong>Gerencia</strong><br>
							<span class="text-secondary text-opacity-75 ellipsis-custom">
								{{ contacto.gerencia[0]?.nombre_gerencia | capitalizeFirstChars }}
							</span>
						</p>
					</li>
					<li class="list-group-item border-0">
						<p class="text-secondary mb-0">
							<strong>Teléfono</strong><br>
							<span class="text-secondary text-opacity-75 ellipsis-custom">
								{{ contacto.telefono_movil ? contacto.telefono_movil : "-"  }}
							</span>
						</p>
					</li>
					<li class="list-group-item border-0">
						<p class="text-secondary mb-0">
							<strong>Correo</strong><br>
							<span class="text-secondary text-opacity-75 ellipsis-custom">
								{{ contacto.correo }}
							</span>
						</p>
					</li>
					<li class="list-group-item border-0">
						<p class="text-secondary mb-0">
							<strong>Anexo</strong><br>
							<span class="text-secondary text-opacity-75 ellipsis-custom">
								{{ contacto.anexo ? contacto.anexo : "-"  }}
							</span>
						</p>
					</li>
				</ul>
			</div>
			<div class="d-flex justify-content-center py-3">
				<a 
					@click="enviarMensaje()"
					href="javascript:" 
					class="btn btn-custom btn-custom-main rounded-4 mw-150"
				>
					Enviar mensaje
				</a>
			</div>
		</div>
	</section>
</template>
<style lang="scss">

</style>